import _extends from "@babel/runtime/helpers/esm/extends";
import { defaultizeColor } from '../../internals/defaultizeColor';
/**
 * This methods is the interface between what the developer is providing and what components receives
 * To simplify the components behaviors, it groups series by type, such that LinePlots props are not updated if some line data are modified
 * It also add defaultized values such as the ids, colors
 * @param series The array of series provided by the developer
 * @param colors The color palette used to defaultize series colors
 * @returns An object structuring all the series by type.
 */
export const preprocessSeries = _ref => {
  let series = _ref.series,
    colors = _ref.colors,
    seriesFormatters = _ref.seriesFormatters,
    dataset = _ref.dataset;
  // Group series by type
  const seriesGroups = {};
  series.forEach((seriesData, seriesIndex) => {
    var _seriesGroups$type;
    const _seriesData$id = seriesData.id,
      id = _seriesData$id === void 0 ? `auto-generated-id-${seriesIndex}` : _seriesData$id,
      type = seriesData.type;
    if (seriesGroups[type] === undefined) {
      seriesGroups[type] = {
        series: {},
        seriesOrder: []
      };
    }
    if (((_seriesGroups$type = seriesGroups[type]) === null || _seriesGroups$type === void 0 ? void 0 : _seriesGroups$type.series[id]) !== undefined) {
      throw new Error(`MUI X: series' id "${id}" is not unique.`);
    }
    seriesGroups[type].series[id] = _extends({
      id
    }, defaultizeColor(seriesData, seriesIndex, colors));
    seriesGroups[type].seriesOrder.push(id);
  });
  const formattedSeries = {};
  // Apply formatter on a type group
  Object.keys(seriesFormatters).forEach(type => {
    const group = seriesGroups[type];
    if (group !== undefined) {
      var _seriesFormatters$typ, _seriesFormatters$typ2;
      formattedSeries[type] = (_seriesFormatters$typ = (_seriesFormatters$typ2 = seriesFormatters[type]) === null || _seriesFormatters$typ2 === void 0 ? void 0 : _seriesFormatters$typ2.call(seriesFormatters, group, dataset)) !== null && _seriesFormatters$typ !== void 0 ? _seriesFormatters$typ : seriesGroups[type];
    }
  });
  return formattedSeries;
};